import { ButtonIcon, DuplicateIcon, Tooltip } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';
import { useCopyCutAndPaste } from 'craft/hooks';

export const CopyButton = () => {
  const { onCopy, canCopy } = useCopyCutAndPaste();

  const isCopyDisabled = !canCopy();

  return (
    <Tooltip
      placement="top"
      offset="xxs"
      content={
        <TooltipBodyWithShortcuts
          content={isCopyDisabled ? 'At least one selected content cannot be copied' : 'Copy'}
          shortcuts={isCopyDisabled ? [] : ['mod', 'C']}
        />
      }
    >
      <ButtonIcon
        size="small"
        icon={DuplicateIcon}
        onClick={onCopy}
        disabled={isCopyDisabled}
        radius="small"
        color="white"
      />
    </Tooltip>
  );
};
